import './index.scss';
import { projectImages } from '../../../public/Assets/Images';
import useViewType from '@/utils/Hooks/useViewType';
import Image from 'next/image';
import { gumletLoader } from '@/utils/gumlet';
const NextStep = () => {
  const handleClick = () => {
    const url = 'https://quiz.growthschool.io/fill/c52dcb42-f641-49ca-ba0a-32af91da8733';
    window.open(url);
  };
  const isMobile = useViewType();
  return <div className="next_step_wrapper" onClick={handleClick} style={{
    cursor: "pointer",
    width: "100%"
  }} data-sentry-component="NextStep" data-sentry-source-file="index.tsx">
      {isMobile ? <img loading='lazy' src={projectImages.nextStepC} alt='mobile' className='mobile_image' /> : <div className="nsq_images_wrapper" style={{
      width: "100%",
      height: "200px",
      position: "relative"
    }}>
        <Image loader={gumletLoader} loading='lazy' className='image_one' fill src={projectImages.NSQhoveranimationnextstep} alt="nsq" />
        <Image loader={gumletLoader} loading='lazy' className='image_two' fill src={projectImages.nsqHover} alt="nsq" />
      </div>}
    </div>;
};
export default NextStep;